// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import SchoolClass from "./school-class.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "primary_school_step": {
      "column": {
        "default": null,
        "name": "primary_school_step",
        "null": true,
        "type": "integer"
      },
      "name": "primary_school_step",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": true
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "ClassStep",
  "collectionKey": "class_steps",
  "collectionName": "class_steps",
  "i18nKey": "class_step",
  "camelizedLower": "classStep",
  "name": "ClassStep",
  "nameDasherized": "class-step",
  "pluralName": "class_steps",
  "ransackable_associations": [
    {
      "className": "ClassStep::Audit",
      "collectionName": "class_step_audits",
      "foreignKey": "class_step_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "ClassStepAudit",
      "through": null
    },
    {
      "className": "BrainBreakClassStep",
      "collectionName": "brain_break_class_steps",
      "foreignKey": "class_step_id",
      "name": "brain_break_class_steps",
      "macro": "has_many",
      "resource_name": "BrainBreakClassStep",
      "through": null
    },
    {
      "className": "ChallengeClassStep",
      "collectionName": "challenge_class_steps",
      "foreignKey": "class_step_id",
      "name": "challenge_class_steps",
      "macro": "has_many",
      "resource_name": "ChallengeClassStep",
      "through": null
    },
    {
      "className": "CheckInClassStep",
      "collectionName": "check_in_class_steps",
      "foreignKey": "class_step_id",
      "name": "check_in_class_steps",
      "macro": "has_many",
      "resource_name": "CheckInClassStep",
      "through": null
    },
    {
      "className": "CourseClassStep",
      "collectionName": "course_class_steps",
      "foreignKey": "class_step_id",
      "name": "course_class_steps",
      "macro": "has_many",
      "resource_name": "CourseClassStep",
      "through": null
    },
    {
      "className": "ClassStep::Audit",
      "collectionName": "class_step_audits",
      "foreignKey": "class_step_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "ClassStepAudit",
      "through": null
    },
    {
      "className": "ClassStep::Translation",
      "collectionName": null,
      "foreignKey": "class_step_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "SchoolClassGroupClassStep",
      "collectionName": "school_class_group_class_steps",
      "foreignKey": "class_step_id",
      "name": "school_class_group_class_steps",
      "macro": "has_many",
      "resource_name": "SchoolClassGroupClassStep",
      "through": null
    },
    {
      "className": "SchoolClassGroup",
      "collectionName": "school_class_groups",
      "foreignKey": "school_class_group_id",
      "name": "school_class_groups",
      "macro": "has_many",
      "resource_name": "SchoolClassGroup",
      "through": "school_class_group_class_steps"
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "class_step_id",
      "name": "school_classes",
      "macro": "has_many",
      "resource_name": "SchoolClass",
      "through": null
    },
    {
      "className": "ClassStep::Translation",
      "collectionName": null,
      "foreignKey": "class_step_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "position",
      "column": {
        "default": "0",
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "primary_school_step",
      "column": {
        "default": null,
        "name": "primary_school_step",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "class_step_id",
      "name": "school_classes",
      "macro": "has_many",
      "resource_name": "SchoolClass",
      "through": null
    }
  ],
  "paramKey": "class_step",
  "primaryKey": "id"
}

/** Frontend model for ClassStep. */
export default class ClassStep extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  primarySchoolStep() {
    return this.readAttributeUnderscore("primary_school_step")
  }

  /** @returns {boolean} */
  hasPrimarySchoolStep() {
    const value = this.primarySchoolStep()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./school-class.js").default>} */
  schoolClasses() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["class_step_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "school_classes",
        model: this,
        modelClass: SchoolClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./school-class.js").default>>} */
  loadSchoolClasses() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["class_step_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "school_classes",
        model: this,
        modelClass: SchoolClass
      },
      {ransack}
    )
  }
}
